import { H2RCheckbox, H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { TextArea } from "../FormElements";
import { replaceWithDataSource } from "../helpers/variable";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export const GraphicEditor = ({
	cue,
	onUpdate,
	dataSources,
}) => {
	const { projectId } = useParams()
	const cloud = useSelector((state) => state.rundown.cloud);
	return (
		<>
			<H2RSelect
				label="Speed"
				selected={cue.speed || "10"}
				options={[
					{
						label: "5 seconds",
						value: "5",
					},
					{
						label: "10 seconds",
						value: "10",
					},
					{
						label: "15 seconds",
						value: "15",
					},
					{
						label: "20 seconds",
						value: "20",
					},
					{
						label: "30 seconds",
						value: "30",
					},
					{
						label: "45 seconds",
						value: "45",
					},
					{
						label: "60 seconds",
						value: "60",
					},
				]}
				onChange={(change) => {
					onUpdate({ speed: change });
				}}
			/>
			<H2RInput
				label="Lead text (Small text)"
				value={cue.lead}
				onChange={(value) => {
					onUpdate({
						lead: value,
					});
				}}
			/>
			<TextArea
				label="Credits (Large text)"
				value={cue.body}
				onChange={(value) => {
					onUpdate({
						body: value,
					});
				}}
			/>
			{!cloud && (
				<H2RSelect
					label="Crowd from data source"
					selected={cue.crowdDataSource || ""}
					options={[
						{
							label: "None",
							value: "none",
						},
						...Object.entries(dataSources)
						.filter(([_, source]) => source?.addedToProjects?.includes(projectId))
						.map(([id, source]) => {
							
							return {
								label: `${source.name || source.details.name} (${id})`,
								value: id,
							};
						}),
					]}
					onChange={(change) => {
						console.log('change',change)
						onUpdate({ crowdDataSource: change });
					}}
				/>
			)}
			{/* <H2RCheckbox
				label="Hide when credits are finished"
				checkboxLabel={cue.hideOnEnd ? 'Yes, hide when finished' : 'No, stay on air'}
				checked={cue.hideOnEnd || false}
				onChange={(checked)=>{
					onUpdate({ hideOnEnd: checked });
				}}
			/> */}
		</>
	);
};

export const GraphicCueContent = ({ cue, dynamicText, dynamicLists }) => {
	return (
		<div className="overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg  whitespace-nowrap overflow-hidden">
			<span className="font-semibold">
				{replaceWithDataSource(cue.lead, dynamicText, dynamicLists, true) ||
					"Credits"}
			</span>
		</div>
	);
};
